import {
  GetTranscriptionJobCommand,
  StartTranscriptionJobCommand,
  TranscribeClient,
  TranscriptionJobStatus
} from '@aws-sdk/client-transcribe';
import {
  AWS_ACCESS_KEY,
  AWS_SECRET_ACCESS_KEY,
  S3_BUCKET_REGION,
  TRANSCRIBE_LANGUAGE_STORAGE_KEY
} from 'data/Config';
import User from 'data/User';
import { getValueFromLocalStorage, newUUID, pause } from 'utils';
import { callFunction } from './FirebaseUtils';
const AWS = require('aws-sdk/global');

let transcribeClient: TranscribeClient;
let currentJobName: string | null = null;

const getClient = (): TranscribeClient => {
  if (!transcribeClient) {
    transcribeClient = new TranscribeClient({
      region: S3_BUCKET_REGION,
      credentials: new AWS.Credentials({
        accessKeyId: AWS_ACCESS_KEY,
        secretAccessKey: AWS_SECRET_ACCESS_KEY
      })
    });
  }
  return transcribeClient;
};

const transcribe = async (
  audioS3Url: string,
  LanguageCode: string
): Promise<any> => {
  const jobName = newUUID();
  const params = {
    TranscriptionJobName: jobName,
    LanguageCode, // For example, 'en-US'
    MediaFormat: 'mp3', // For example, 'wav'
    Media: {
      MediaFileUri: audioS3Url
    }
  };
  const result = await getClient().send(
    new StartTranscriptionJobCommand(params)
  );
  if (
    result.TranscriptionJob?.TranscriptionJobStatus ===
    TranscriptionJobStatus.IN_PROGRESS
  ) {
    currentJobName = jobName;
    while (true) {
      await pause(3000);
      if (!currentJobName) {
        // job cancelled by user
        throw new Error('User cancelled job');
      }
      const data = await getClient().send(
        new GetTranscriptionJobCommand({ TranscriptionJobName: jobName })
      );
      const status = data.TranscriptionJob?.TranscriptionJobStatus;
      console.log(status);
      switch (status) {
        case TranscriptionJobStatus.COMPLETED:
          const transcriptUrl =
            data.TranscriptionJob?.Transcript?.TranscriptFileUri!;
          const response = await callFunction('proxy', transcriptUrl);
          currentJobName = null;
          return JSON.parse(response.data);
        case TranscriptionJobStatus.FAILED:
          throw new Error(data.TranscriptionJob?.FailureReason);
        default:
        // do nothing
      }
    }
  } else {
    throw new Error(result.TranscriptionJob?.FailureReason);
  }
};

const cancelTranscribeJob = () => {
  currentJobName = null;
};

const SUPPORTED_LANGUAGES = {
  'af-ZA': 'Afrikaans (South Africa)',
  'ar-AE': 'Arabic (U.A.E.)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'zh-CN': "Chinese (People's Republic of China)",
  'zh-TW': 'Chinese (Taiwan)',
  'da-DK': 'Danish (Denmark)',
  'nl-NL': 'Dutch (Netherlands)',
  'en-AB': 'English (Alberta)',
  'en-AU': 'English (Australia)',
  'en-IE': 'English (Ireland)',
  'en-IN': 'English (India)',
  'en-NZ': 'English (New Zealand)',
  'en-WL': 'English (Saint Lucia)',
  'en-ZA': 'English (South Africa)',
  'en-GB': 'English (United Kingdom)',
  'en-US': 'English (United States)',
  'fa-IR': 'Farsi (Iran)',
  'fr-CA': 'French (Canada)',
  'fr-FR': 'French (France)',
  'de-DE': 'German (Germany)',
  'de-CH': 'German (Switzerland)',
  'he-IL': 'Hebrew (Israel)',
  'hi-IN': 'Hindi (India)',
  'id-ID': 'Indonesian (Indonesia)',
  'ga-IE': 'Irish (Ireland)',
  'it-IT': 'Italian (Italy)',
  'ja-JP': 'Japanese (Japan)',
  'ko-KR': 'Korean (Korea)',
  'ms-MY': 'Malay (Malaysia)',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese (Portugal)',
  'ru-RU': 'Russian (Russia)',
  'gd-GB': 'Scottish Gaelic (United Kingdom)',
  'es-ES': 'Spanish (Castilian)',
  'es-US': 'Spanish (United States)',
  'ta-IN': 'Tamil (India)',
  'te-IN': 'Telugu (India)',
  'tr-TR': 'Turkish (Turkey)',
  'th-TH': 'Thai (Thailand)',
  'cy-GB': 'Welsh (United Kingdom)'
};

const getSpokenLanguage = (user: User | null): string | undefined => {
  const savedLanguage =
    user?.transcribeSpokenLanguage ||
    getValueFromLocalStorage(TRANSCRIBE_LANGUAGE_STORAGE_KEY);
  if (savedLanguage) {
    return savedLanguage;
  }
  if (SUPPORTED_LANGUAGES[navigator.language]) {
    return navigator.language;
  }
  return undefined;
};

export {
  transcribe,
  cancelTranscribeJob,
  SUPPORTED_LANGUAGES,
  getSpokenLanguage
};



// WEBPACK FOOTER //
// ./src/utils/Transcribe.ts